import React, { useEffect, useState, Suspense } from "react";
import { withRouter, Route, Redirect, useHistory, Switch } from "react-router-dom";
import getSource from "../utils/get-source";
import { parseQueryString, setLeadId } from "../utils/utils";
import { initialState, combineReducers } from "../reducers";
import { AppStateProvider } from "../contexts/appState";
// import { StateProvider } from "../components/SlotFinder/store/stateProvider";
// import reducer, { initialStates } from "../components/SlotFinder/store/reducer";
import userReducer from "../reducers/userReducer";
import Header from "./Header";
import "./styles/homescreen.css";
import Footer from "./Footer/Footer";
// import VaccinationCertiReliance from './VaccinationCertificate/Reliance';
import { useIsTablet, useIsMobile } from "../hooks/breakpoints";
import useTranslation from "../hooks/use-translation";
import { _getItemFromSession } from "../utils/Helpers/SessionKeys";
import Loader from "./Loader";
import { _setItemInLocal } from "../utils/LocalKeys";

const Homepage = React.lazy(() => import("./Homepage"));
const OnBoardingWrapper = React.lazy(() => import("./OnboardingWrapper"));
const Authorise = React.lazy(() => import("./PlugAndPlay"));

const routes = {
    "/": <Homepage />,
    "/get-started": <OnBoardingWrapper />,
    "/authorise": <Authorise />,
    "/:questionId": <OnBoardingWrapper />,
};

const getSourceId = async () => {
    const { source_id }: any = parseQueryString();
    if (source_id) {
        return Promise.resolve(source_id);
    }
    const sourceData = await getSource();
    return sourceData.source_id;
};
const appReducers = combineReducers({
    user: userReducer,
});

const Routes = () => {
    const [state, setState] = useState({
        source_id: null,
    });
    const [hideHeader, setHideHeader] = useState(false);
    const isMobile = useIsMobile();
    const { t } = useTranslation();
    const urlParams: any = parseQueryString();
    useEffect(() => {
        (async () => {
            const source_id = await getSourceId();
            setState((prevState) => ({
                ...prevState,
                source_id,
            }));
             //@ts-ignore
            setHideHeader(() => (parseQueryString().hideHeader == "false" ? false : true));
        })();
        //create lead id for current session
        setLeadId(urlParams?.lead_id);
        if (urlParams?.primary_source) {
            _setItemInLocal("primary_source", urlParams?.primary_source);
        }
    }, []);

    const isTablet = useIsTablet();
    const history = useHistory();
    return (
        <Suspense fallback={<Loader loadingCount={1} overlay={true} />}>
            <AppStateProvider reducer={appReducers} initialState={initialState}>
                <div
                    style={{
                        minHeight: "100vh",
                        // height: "100vh",
                        backgroundColor: "#F6F6F6",
                    }}
                    onCopy={(e) => e.preventDefault()}
                >
                    {/* <Header
                    shouldHide={false}
                    headerText={t("SURVEY_MAIN_TITLE")}
                    // shouldHide={
                    //     state.source_id &&
                    //     (state.source_id === "JioHealthHub" ||
                    //         state.source_id === "MyJio" ||
                    //         state.source_id === "JhhWebApp") &&
                    //     hideHeader
                    // }
                /> */}
                    <Switch>
                        {Object.entries(routes).map(([path, component]) => (
                            <Route exact key={path} path={path}>
                                <div
                                    className={`component ${
                                        (state.source_id &&
                                            (state.source_id === "JioHealthHub" || state.source_id === "MyJio")) ||
                                        state.source_id === "JhhWebApp"
                                            ? "paddingBottomSmall"
                                            : ""
                                    }`}
                                    style={{ height: "100%", width: "100%" }}
                                >
                                    <Suspense fallback={<Loader loadingCount={1} overlay={true} />}>
                                        {component}
                                    </Suspense>
                                </div>
                            </Route>
                        ))}
                        <Route>
                            <Redirect to="/" />
                        </Route>
                    </Switch>
                    {_getItemFromSession("_pnp") !== "true" && (
                        <Footer
                            shouldHide={
                                (state.source_id &&
                                    (state.source_id === "JioHealthHub" || state.source_id === "MyJio")) ||
                                state.source_id === "JhhWebApp"
                            }
                        />
                    )}
                </div>
            </AppStateProvider>
        </Suspense>
    );
};
export default Routes;
